import React from 'react';
import PropTypes from 'prop-types';

class CallToActionExploreBlock extends React.Component {
    constructor(props) {
        super(props);
    }

    
    render() {
        const style = this.props.image && this.props.image !== "null"
            ? { 'backgroundImage': 'url(' + this.props.image + ')', 'backgroundColor': this.props.color}
            : { 'backgroundColor': this.props.color };
        const overlayStyle = this.props.overlayToggle === "True"
            ? { 'backgroundColor': 'rgba(' + this.props.overlayColor + ', .35)' }
            : { };
        return (
            <div className="teaser teaser--bg-image" style={style}>
                <a href={this.props.linkUrl} style={overlayStyle}>
                <div className="teaser__body">
                    <p className="teaser__text block-quote">{this.props.text}</p>
                    <p className="teaser__link text-standard fw-600">{this.props.linkText}</p>
                </div>
                </a>
            </div>
        );
    }
}

CallToActionExploreBlock.propTypes = {
    text: PropTypes.string,
    color: PropTypes.string,
    image: PropTypes.string,
    linkUrl: PropTypes.string,
    linkText: PropTypes.string,
    overlayColor: PropTypes.string,
    overlayToggle: PropTypes.string
};

export default CallToActionExploreBlock;